<script setup lang="ts">
  import { defineProps } from 'vue'
  const props = defineProps({
    helpText: {
      type: String,
      default: ''
    }
  })
</script>

<template>
  <span>{{ props.helpText }}</span>
</template>
